<template>
  <x-page :loading="loading" classical title="新春年货节">
    <template v-if="!loading">
      <!-- 头图 -->
      <div :class="_.headImage">
        <div
          :class="_.rule"
          @click="goRule(homeData.跳转配置 && homeData.跳转配置[0].targetUrl)"
        >
          活动规则
        </div>
      </div>

      <div :class="_.main">
        <!-- 容器 -->
        <div
          v-if="homeData.主题二级分类 && homeData.主题二级分类.length"
          :class="_.container"
        >
          <!-- 推荐商品 -->
          <div
            v-for="(item, index) in homeData.主题二级分类"
            :key="index"
            :class="_.recommend"
          >
            <img :class="_.title" :src="item.icon" alt="" />
            <div :class="_.con">
              <div
                v-if="item.goodsList && item.goodsList.length"
                :class="_.goodsList"
              >
                <div
                  v-for="item in item.goodsList.slice(0, 6)"
                  :key="item.id"
                  :class="_.good"
                  @click="$handleResourceClick(item, item.title)"
                >
                  <img v-lazy="item.icon" :src="item.icon" alt="" />
                  <div :class="_.text">
                    <p class="van-ellipsis">{{ item.title }}</p>
                    <p>
                      <span><font>￥</font>{{ item.discountAmt }}</span>
                      <!-- <del>￥{{ item.amt }}</del> -->
                    </p>
                  </div>
                </div>
              </div>

              <div
                v-if="item.targetUrl"
                :class="_.more"
                @click="$handleResourceClick(item, item.title)"
              >
                查看更多
              </div>
            </div>
          </div>

          <!-- 更多商品 -->
          <div v-if="!isEmpty" :class="_.waterfall">
            <div :class="_.title">
              <img :class="_.left" src="./images/更多好物_左.png" alt="" />
              <div>更多好物</div>
              <img src="./images/更多好物_右.png" alt="" />
            </div>
            <!-- <div :class="_.title">更多好物</div> -->
            <x-waterfall :load="handleLoad" no-complete-tips>
              <template #default="{ data }">
                <x-masonry :class="_.list" :col-count="2" :gap="12">
                  <div
                    v-for="(item, index) in data"
                    :key="index"
                    v-track="{
                      name: '多多商城_2025新春年货活动_更多好物',
                      newId: 'shou_ye_re_men_tui_jian',
                      extra: {
                        tui_jian_lei_xing: '更多商品',
                        chan_pin_wei_zhi: 4,
                        shang_pin_id: item.id || '',
                        track_code: 'f0db3c64c09d45de986a422fd5c908f8',
                      },
                    }"
                    :class="_.item"
                    @click="$handleResourceClick(item, '首页更多商品')"
                  >
                    <x-square>
                      <img :src="item.icon" :class="_.cover" />
                    </x-square>
                    <div :class="_.content">
                      <div :class="_.name">
                        {{ item.title }}
                      </div>
                      <div v-if="item.tags && item.tags.length" :class="_.tags">
                        <div v-for="tag in item.tags" :key="tag" :class="_.tag">
                          {{ tag }}
                        </div>
                      </div>
                      <div :class="_.extra">
                        <div :class="_.price">
                          <span>￥</span>{{ item.discountAmt }}
                        </div>
                        <div :class="_.sales">销量 {{ item.sales }}</div>
                      </div>
                    </div>
                  </div>
                </x-masonry>
              </template>
            </x-waterfall>
          </div>
        </div>
      </div>
    </template>
  </x-page>
</template>

<script>
  import Vue from 'vue'
  import {
    apiPageConfigDecorateGetData,
    apiPageConfigDecorateSearchData,
  } from '@/api'
  import { fromPairs } from 'vtils'
  import { globalModel } from '@/model'
  import { prepareData, pxToRem, requiredDeep } from '@/utils'
  // import { navigateTo } from '@/router'
  import { dcb } from '@dcb/jssdk'
  import { openMap } from '@/utils'

  export default Vue.extend({
    props: {
      pageHdHeight: {
        type: Number,
        required: true,
      },
    },

    data: () => ({
      // 页面级加载状态
      loading: true,

      isEmpty: false,

      // 首页数据
      homeData: {},

      // 是否内嵌
      isEmbed: globalModel.state.isEmbed,
    }),

    activated() {
      this.prepareData()
    },

    methods: {
      pxToRem: pxToRem,

      // 准备数据
      async prepareData() {
        const { homeData } = await prepareData({
          homeData: Promise.all(
            [
              '多多商城_2025新春年货活动_主题二级分类',
              '多多商城_2025新春年货活动_主题二级分类_跳转配置',
              '多多商城_2025新春年货活动_跳转配置',
            ].map(async id => [
              id.replace('多多商城_2025新春年货活动_', '').replace(/-/g, '_'),
              await apiPageConfigDecorateSearchData(
                {
                  id: id,
                  pageIndex: 1,
                  pageSize: 100,
                },
                {
                  name: id,
                },
              )
                .then(requiredDeep)
                .then(res => res.list),
            ]),
          ).then(res => fromPairs(res)),
        })

        await Promise.all(
          homeData.主题二级分类.map(async ({ id, stateName }, index) => [
            await apiPageConfigDecorateGetData(
              {
                id: '多多商城_2025新春年货活动_主题二级分类',
                innerId: id,
                pageIndex: 1,
                pageSize: 6,
              },
              {
                name: stateName,
              },
            )
              .then(requiredDeep)
              .then(res => res.list)
              .then(res => {
                homeData.主题二级分类[index].goodsList = res || []
                homeData.主题二级分类[index].targetUrl =
                  homeData.主题二级分类_跳转配置[index].targetUrl
              }),
          ]),
        )

        this.homeData = homeData
        this.loading = false
      },

      async handleLoad({ pageNumber }) {
        const res = await apiPageConfigDecorateSearchData(
          {
            id: '多多商城_2025新春年货活动_更多好物',
            pageIndex: pageNumber,
            pageSize: 10,
          },
          {
            name: '多多商城_2025新春年货活动_更多好物',
          },
        )
        if (pageNumber === 1 && !res.list?.length) {
          this.isEmpty = true
        }
        return res
      },
      goMap() {
        openMap({
          name: '贵阳市南明区龙洞堡老里坡1号',
          latitude: '26.529697',
          longitude: '106.789156',
        })
      },
      goRule(url) {
        dcb.navigateTo({ url })
      },
    },
  })
</script>

<style lang="scss" module>
  .headImage {
    position: relative;
    width: 100%;
    height: 457px;
    background-image: url('./images/头图.png');
    background-size: 100% 100%;
    background-repeat: no-repeat;
    background-position: center;
    .rule {
      position: absolute;
      right: 0;
      bottom: 160px;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      font-family: PingFangSC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #ffffff;
      line-height: 20px;
      text-align: center;
      font-style: normal;
      background: rgba(0, 0, 0, 0.6);
      border-radius: 100px 0px 0px 100px;
      padding: 5px 12px;
    }
  }

  .main {
    position: relative;
    // margin-top: calc(var(--page-header-height) - 75px + 12px);
    font-size: 0;

    .container {
      margin-top: -90px;
      background: url('./images/通用背景.png');
      padding: 0 12px 12px;

      .recommend {
        margin-bottom: 14px;
        box-sizing: border-box;

        .title {
          width: 351px;
          height: 82px;
          vertical-align: middle;
        }

        .con {
          // margin-top: -1px;
          // background: linear-gradient(90deg, #ffefe2 0%, #ffd3a4 100%);
          background: url('./images/商品分类背景.png');
          background-size: 100% 100%;
          padding-bottom: 16px;
          border-radius: 0 0 8px 8px;
          padding-top: 1px;

          .goodsList {
            display: flex;
            flex-wrap: wrap;
            padding: 0 8px;

            .good {
              width: 106px;
              margin-right: 8px;
              margin-bottom: 10px;
              &:nth-child(3n) {
                margin-right: 0;
              }
              img {
                width: 106px;
                height: 106px;
                vertical-align: middle;
                object-fit: cover;
                border-radius: 8px 8px 0 0;
                // overflow: hidden;
              }
              .text {
                // overflow: hidden;
                font-size: 13px;
                padding: 6px;
                background: #ffffff;
                border-radius: 0 0 6px 6px;
                border: 1px solid #e9e9e9;
                border-top: 0;
                p:nth-child(1) {
                  font-family: PingFangSC, PingFang SC;
                  font-weight: 500;
                  font-size: 13px;
                  color: #333333;
                  line-height: 18px;
                  text-align: justify;
                  font-style: normal;
                }
                p:nth-child(2) {
                  display: flex;
                  justify-content: space-between;
                  margin-top: 8px;
                  font-size: 9px;
                  span {
                    font-family: PingFangSC, PingFang SC;
                    font-size: 12px;
                    font-weight: 500;
                    color: #fe3134;
                    line-height: 13px;
                    text-align: left;
                    font-style: normal;
                    font {
                      font-size: 9px;
                      font-weight: 400;
                    }
                  }
                  del {
                    font-family: PingFangSC, PingFang SC;
                    font-weight: 400;
                    font-size: 9px;
                    color: #999999;
                    line-height: 13px;
                    text-align: right;
                    font-style: normal;
                  }
                }
              }
            }
          }
          .more {
            width: 293px;
            height: 46px;
            background: url('./images/查看更多_主题页.png');
            background-size: 100% 100%;
            margin: 6px auto 0;
            font-family: PingFangSC, PingFang SC;
            font-weight: 500;
            font-size: 16px;
            color: #ffffff;
            line-height: 46px;
            text-align: center;
            font-style: normal;
          }
        }
      }

      .waterfall {
        margin-top: 12px;

        .title {
          display: flex;
          align-items: center;
          justify-content: center;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
          line-height: 25px;
          font-style: normal;
          margin-bottom: 16px;
          text-align: center;
          img {
            width: 30px;
            height: 8px;
          }
          div {
            margin: 0 8px;
          }
        }

        .list {
          .item {
            background: #ffffff;
            border-radius: 8px;
            overflow: hidden;

            .cover {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }

            .content {
              padding: 8px;

              .name {
                font-size: 14px;
                font-weight: var(--bold-value);
                color: #333333;
                line-height: 20px;
                display: -webkit-box;
                overflow: hidden;
                text-overflow: ellipsis;
                -webkit-line-clamp: 2;
                -webkit-box-orient: vertical;
              }

              .tags {
                --gap: 8px;
                --margin-top: 8px;
                display: flex;
                flex-wrap: wrap;
                margin-top: calc(var(--gap) - var(--margin-top));

                .tag {
                  margin-top: var(--gap);
                  margin-right: var(--gap);
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: #fff4e6;
                  color: #ff960a;
                  padding: 3px 6px;
                  border-radius: 4px;
                  font-size: 12px;
                  line-height: 17px;
                }
              }

              .extra {
                margin-top: 8px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                .price {
                  font-size: 18px;
                  font-weight: var(--bold-value);
                  color: #ff3b30;
                  line-height: 25px;

                  span {
                    font-size: 12px;
                    font-weight: normal;
                    color: #ff3b30;
                    line-height: 17px;
                  }
                }

                .sales {
                  font-size: 12px;
                  color: #b4b4b4;
                  line-height: 17px;
                }
              }
            }
          }
        }
      }
    }
  }
</style>
